import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "./api/authApi";
import { servicesApi } from "./api/servicesApi";
import { blogsApi } from "./api/blogsApi";
import { contentApi } from "./api/contentApi";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [blogsApi.reducerPath]: blogsApi.reducer,
    [contentApi.reducerPath]: contentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(servicesApi.middleware)
      .concat(blogsApi.middleware)
      .concat(contentApi.middleware),
});
